import { t } from "i18next";
import { useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Select } from "ui";

import { useProductBadgesSelectorList } from "../../../../../hooks";
import { ProductBadge } from "../../../../ProductBadge";
import { ProductFormValues } from "../../ProductDetailsForm.types";
import { VariantBlockPartProps } from "./VariantBlock.types";

import styles from "../../ProductDetailsForm.module.scss";

export const VariantBadgeBlock = ({ variantIndex }: VariantBlockPartProps) => {
  const { control } = useFormContext<ProductFormValues>();
  const { badges, isLoading } = useProductBadgesSelectorList();

  const badgeOptions = useMemo(
    () => [
      { label: t("No Badge"), value: "" },
      ...(badges?.map((badge) => ({
        label: <ProductBadge badge={badge} />,
        value: badge.id
      })) ?? [])
    ],
    [badges]
  );

  return (
    <div className={styles.productForm__block} style={{ minWidth: 250 }}>
      <Controller
        control={control}
        name={`variants.${variantIndex}.badgeId`}
        render={({
          field: { value, onChange },
          fieldState: { error: _error }
        }) => (
          <Select
            label={t("Product Badge")}
            options={badgeOptions}
            value={value}
            isOptionsLoading={isLoading}
            onChange={onChange}
            placeholder={t("Select Product Badge")}
          />
        )}
      />
    </div>
  );
};
